import React from 'react';
import './StatusBadge.css';

/**
 * A reusable StatusBadge component for consistent status styling across the app.
 *
 * @param {Object} props
 * @param {string} props.status - The status string (e.g., 'A', 'Active', 'P', 'Pending', 'L', 'Locked').
 * @param {string} props.className - Additional custom class names.
 */
const StatusBadge = ({ status, className = '' }) => {
  const getStatusBadgeClass = (statusStr) => {
    if (!statusStr || (typeof statusStr !== 'string' && typeof statusStr !== 'number')) {
      return 'status-badge-total';
    }
    const upperStatus = statusStr.toString().toUpperCase();
    if (upperStatus === 'A' || upperStatus === 'ACTIVE') {
      return 'status-badge-active';
    } else if (upperStatus === '2') {
      return 'status-badge-active';
    } else if (upperStatus === 'P' || upperStatus === 'PENDING') {
      return 'status-badge-pending';
    } else if (upperStatus === '3') {
      return 'status-badge-pending';
    } else if (upperStatus === 'S' || upperStatus === 'SENT' || upperStatus === 'SUCCESS') {
      return 'status-badge-active';
    } else if (upperStatus === 'L' || upperStatus === 'LOCKED') {
      return 'status-badge-locked';
    } else if (upperStatus === '4') {
      return 'status-badge-locked';
    } else if (
      upperStatus === 'INACTIVE' ||
      upperStatus === 'I' ||
      upperStatus === 'I/A' ||
      upperStatus === 'IN/A' ||
      upperStatus === 'FAILED' ||
      upperStatus === 'ERROR'
    ) {
      return 'status-badge-inactive';
    } else {
      return 'status-badge-total';
    }
  };

  const getStatusDisplay = (statusStr) => {
    if (!statusStr || (typeof statusStr !== 'string' && typeof statusStr !== 'number')) {
      return 'Unknown';
    }
    const upperStatus = statusStr.toString().toUpperCase();
    if (upperStatus === 'ACTIVE' || upperStatus === 'A' || upperStatus === '2') return 'Active';
    if (upperStatus === 'PENDING' || upperStatus === 'P' || upperStatus === '3') return 'Pending';
    if (upperStatus === 'SENT' || upperStatus === 'SUCCESS' || upperStatus === 'S') return 'Sent';
    if (upperStatus === 'LOCKED' || upperStatus === 'L' || upperStatus === '4') return 'Locked';
    if (upperStatus === 'FAILED' || upperStatus === 'ERROR') return 'Failed';
    if (upperStatus === 'INACTIVE' || upperStatus === 'I' || upperStatus === 'I/A' || upperStatus === 'IN/A') return 'Inactive';
    return statusStr.toString();
  };

  const badgeClass = `status-badge ${getStatusBadgeClass(status)} ${className}`;

  return (
    <span className={badgeClass}>
      {getStatusDisplay(status)}
    </span>
  );
};

export default StatusBadge;
